import Swiper from 'swiper';
import { EffectFade, Navigation, Pagination } from 'swiper/modules';
import { gsap } from 'gsap';
import { md, lg, xl, wide, xwide } from '../common';
import { bindElementSizeProperties } from '../lib/bindElementSizeProperties';

export function initCardsHero(selector = '.js-cards-hero') {
  const parent = document.querySelector('.js-cards-hero');
  if (!parent) return;

  const cards = parent.querySelectorAll('.cards-hero__card');
  cards.forEach((card, index) => {
    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      transformOrigin: 'center center',
    });

    const tl = gsap.timeline({});

    const nums = card.querySelectorAll('[data-counter-to]');
    nums.forEach((num) => {
      const to = parseInt(num.dataset.counterTo, 10);
      tl.counter(
        num,
        {
          end: to,
          increment: 1,
          duration: 0.75,
        },
        '<',
      );
    });

    tl.to(
      card,
      {
        opacity: 1,
        scale: 1.02,
        duration: 0.5,
        ease: 'power1.out',
        delay: index * 0.1,
      },
      '<',
    );
    tl.to(card, {
      scale: 1,
      duration: 0.3,
      ease: 'power1.inOut',
    });
  });
}
